import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { AuthLoginActionTypes } from './authTypes';
import {
  authLoginApiResponseSuccess,
  authLoginApiResponseError,
} from './authActions';
import {
  nodeLogin,
  postSocialLogin,
  postGoogleLogin,
  getGoogleVerify,
  postVerifyCaptcha,
  getGmailVerify,
  verifyEmailOTP as verifyEmailOTPApi,
  sendEmailOTP as sendEmailOTPApi,
  logout
} from '../../api/authNode'
import { persistor } from '../store/index';
import { AtSign } from 'react-feather';

import { registrationOptionsPasskeyApi } from '../../api/authNode';
import { registrationVerifyPasskeyApi } from '../../api/authNode';
import { loginOptionsPasskeyApi } from '../../api/authNode';
import { loginVerifyPasskeyApi } from '../../api/authNode';
import { registeredDevicesPasskeyApi } from '../../api/authNode';
import { sessionCheckApi } from '../../api/authNode';

import { showSuccessNotification, showErrorNotification } from "../../../src/helpers/NotificationContext"
import { manualLoginSignUpApi } from '../../api/authNode';


function* loginUser({ payload: { user } }: any) {
  try {
    const response: Promise<any> = yield call(nodeLogin, {
      email: user.email,
      password: user.password,
    });
    yield put(
      authLoginApiResponseSuccess(AuthLoginActionTypes.LOGIN_USER, response)
    );

  } catch (error: any) {
    yield put(
      authLoginApiResponseError(AuthLoginActionTypes.LOGIN_USER, error)
    );
  }
}

function* socialLogin({ payload: { data, type } }: any) {
  try {
    const response: Promise<any> = yield call(postGoogleLogin, null);
    yield put(
      authLoginApiResponseSuccess(AuthLoginActionTypes.LOGIN_USER, response)
    );
  } catch (error: any) {
    yield put(
      authLoginApiResponseError(AuthLoginActionTypes.LOGIN_USER, error)
    );
  }
}

function* googleVerify() {
  try {
    const response: Promise<any> = yield call(getGoogleVerify);
    yield put(
      authLoginApiResponseSuccess(AuthLoginActionTypes.GOOGLE_VERIFY, response)
    );
    // 🔥 Force persist after successful login
    yield call([persistor, persistor.flush]);
    console.log("Forced persist flush done");
  } catch (error: any) {
    yield put(
      authLoginApiResponseError(AuthLoginActionTypes.GOOGLE_VERIFY, error)
    );
  }
}

function* gmailVerify() {
  try {
    const response: Promise<any> = yield call(getGmailVerify);
    yield put(
      authLoginApiResponseSuccess(AuthLoginActionTypes.GMAIL_VERIFY, response)
    );
  } catch (error: any) {
    yield put(
      authLoginApiResponseError(AuthLoginActionTypes.GMAIL_VERIFY, error)
    );
  }
}


function* verifyCaptcha({ payload: { data } }: any) {
  try {
    const response: Promise<any> = yield call(postVerifyCaptcha, { data });
    yield put(
      authLoginApiResponseSuccess(AuthLoginActionTypes.CAPTCHA_VERIFY, response)
    );
  } catch (error: any) {
    yield put(
      authLoginApiResponseError(AuthLoginActionTypes.CAPTCHA_VERIFY, error)
    );
  }
}

// function* updateTrackAbility({ payload: { id } }: any) {
//   try {
//     console.log("track about to call api Trackablity", id )
//     const response: Promise<any> = yield call(updateTrackAbilityApi, id );
//     console.log("track post api call ", response)
//     yield put(
//       authLoginApiResponseError(AuthLoginActionTypes.UPDATE_CONTACT_TRACK_ABILITY, response)
//     );
//   } catch (error: any) {
//     yield put(
//       authLoginApiResponseError(AuthLoginActionTypes.UPDATE_CONTACT_TRACK_ABILITY, error)
//     );
//   }
// }

function* verifyAdminOTP({ payload: { data } }: any) {
  try {
    const response: Promise<any> = yield call(verifyEmailOTPApi, { data });
    yield put(
      authLoginApiResponseSuccess(AuthLoginActionTypes.ADMIN_OTP_VERIFY, response)
    );
    yield put(authLoginApiResponseSuccess('OTP Verified', response));
  } catch (error: any) {
    yield put(
      authLoginApiResponseError(AuthLoginActionTypes.ADMIN_OTP_VERIFY, error)
    );
  }
}


function* sendEmailOTP({ payload: { email } }: any) {
  try {
    console.log("inside saga function for get AdminOTP")
    const response: Promise<any> = yield call(sendEmailOTPApi, { email });
    yield put(
      authLoginApiResponseSuccess(AuthLoginActionTypes.SEND_ADMIN_OTP, response)
    );
    yield put(authLoginApiResponseSuccess('OTP Sent Successfully', response));
  } catch (error: any) {
    yield put(
      authLoginApiResponseError(AuthLoginActionTypes.SEND_ADMIN_OTP, error)
    );
  }
}


function* logoutUser() {
  try {
    // Call the API to log out
    const response: Promise<any> = yield call(logout);

    // Remove user data from local storage after successful API call
    localStorage.removeItem('authUser');

    // Clear persisted state
    yield call([persistor, 'purge']); // Purge persisted state

    yield put(
      authLoginApiResponseSuccess(AuthLoginActionTypes.LOGOUT_USER, response)
    );
  } catch (error: any) {
    yield put(
      authLoginApiResponseError(AuthLoginActionTypes.LOGOUT_USER, error)
    );
  }
}

function* registrationOptionsPasskeySaga(action: any) {
  try {
    console.log("[authSaga.ts] registrationOptionsPasskeySaga action.payload", action.payload);

    // const transcript = action.payload;
    // console.log("sendApproveEntrySaga sending transcript to api:", transcript);
    const response = yield call(registrationOptionsPasskeyApi);
    console.log("Backend response from registrationOptionsPasskeySaga: ", response);
    yield put(authLoginApiResponseSuccess(AuthLoginActionTypes.REGISTRATION_OPTIONS_PASSKEY, response));
    // yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.SEND_APPROVED_ENTRY, response));
    showSuccessNotification("✅ UI state loaded from file");

  } catch (error: any) {
    console.error("[authSaga.ts] Saga error loading state from file:", error.message);
    yield put(authLoginApiResponseError(AuthLoginActionTypes.REGISTRATION_OPTIONS_PASSKEY, error.message));
    showErrorNotification("State load failed: " + error.message);
  }
}

function* registrationVerifyPasskeySaga(action: any) {
  try {
    console.log("[sendApproveEntrySaga] registrationVerifyPasskeySaga action.payload", action.payload);

    const transcript = action.payload;
    console.log("registrationVerifyPasskeySaga sending transcript to api:", transcript);
    const response = yield call(registrationVerifyPasskeyApi, transcript);
    console.log("Backend response from registrationVerifyPasskeySaga: ", response);
    yield put(authLoginApiResponseSuccess(AuthLoginActionTypes.REGISTRATION_VERIFY_PASSKEY, response));
    showSuccessNotification(`🚀 Booking details fetched successfully!`);

  } catch (error: any) {
    console.error(" registrationVerifyPasskeySaga Saga error fetching booking details:", error.message);
    yield put(authLoginApiResponseError(AuthLoginActionTypes.REGISTRATION_VERIFY_PASSKEY, error.message));
    showErrorNotification("Execution failed: " + error.message);
  }
}

function* loginOptionsPasskeySaga(action: any) {
  try {
    console.log("[authSaga.ts] LOGIN_OPTIONS_PASSKEY action.payload", action.payload);

    // const transcript = action.payload;
    // console.log("sendApproveEntrySaga sending transcript to api:", transcript);
    const response = yield call(loginOptionsPasskeyApi);
    console.log("Backend response from LOGIN_OPTIONS_PASSKEY: ", response);
    yield put(authLoginApiResponseSuccess(AuthLoginActionTypes.LOGIN_OPTIONS_PASSKEY, response));
    // yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.SEND_APPROVED_ENTRY, response));
    showSuccessNotification("✅ UI state loaded from file");

  } catch (error: any) {
    console.error("[authSaga.ts] Saga error loading state from file:", error.message);
    yield put(authLoginApiResponseError(AuthLoginActionTypes.LOGIN_OPTIONS_PASSKEY, error.message));
    showErrorNotification("State load failed: " + error.message);
  }
}


function* loginVerifyPasskeySaga(action: any) {
  try {
    console.log("[loginVerifyPasskeySaga] loginVerifyPasskeySaga action.payload", action.payload);

    const transcript = action.payload;
    console.log("loginVerifyPasskeySaga sending transcript to api:", transcript);
    const response = yield call(loginVerifyPasskeyApi, transcript);
    console.log("Backend response from loginVerifyPasskeySaga: ", response);
    yield put(authLoginApiResponseSuccess(AuthLoginActionTypes.LOGIN_VERIFY_PASSKEY, response));
    showSuccessNotification(`🚀 Booking details fetched successfully!`);

  } catch (error: any) {
    console.error(" loginVerifyPasskeySaga Saga error fetching booking details:", error.message);
    yield put(authLoginApiResponseError(AuthLoginActionTypes.LOGIN_VERIFY_PASSKEY, error.message));
    showErrorNotification("Execution failed: " + error.message);
  }
}

function* registeredDevicesPasskeySaga(action: any) {
  try {
    console.log("[authSaga.ts] registeredDevicesPasskeySaga action.payload", action.payload);

    // const transcript = action.payload;
    // console.log("sendApproveEntrySaga sending transcript to api:", transcript);
    const response = yield call(registeredDevicesPasskeyApi);
    console.log("Backend response from registeredDevicesPasskeySaga: ", response);
    yield put(authLoginApiResponseSuccess(AuthLoginActionTypes.REGISTERED_DEVICES_PASSKEY, response));
    // yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.SEND_APPROVED_ENTRY, response));
    showSuccessNotification("✅ UI state loaded from file");

  } catch (error: any) {
    console.error("[authSaga.ts] Saga error loading state from file:", error.message);
    yield put(authLoginApiResponseError(AuthLoginActionTypes.REGISTERED_DEVICES_PASSKEY, error.message));
    showErrorNotification("State load failed: " + error.message);
  }
}



function* sessionCheckSaga(action: any) {
  try {
    console.log("[authSaga.ts] sessionCheckSaga action.payload", action.payload);

    // const transcript = action.payload;
    // console.log("sendApproveEntrySaga sending transcript to api:", transcript);
    const response = yield call(sessionCheckApi);
    console.log("Backend response from sessionCheckSaga: ", response);
    yield put(authLoginApiResponseSuccess(AuthLoginActionTypes.SESSION_CHECK, response));
    // yield put(uiChatApiResponseSuccess(uiChatReducerActionTypes.SEND_APPROVED_ENTRY, response));
    showSuccessNotification("✅ UI state loaded from file");

  } catch (error: any) {
    console.error("[authSaga.ts] Saga error loading state from file:", error.message);
    yield put(authLoginApiResponseError(AuthLoginActionTypes.SESSION_CHECK, error.message));
    showErrorNotification("State load failed: " + error.message);
  }
}



function* manualLoginSignUpSaga(action: any) {
  try {
    console.log("[manualLoginSignUpSaga] manualLoginSignUpSaga action.payload", action.payload);

    const transcript = action.payload;
    console.log("manualLoginSignUpSaga sending transcript to api:", transcript);
    const response = yield call(manualLoginSignUpApi, transcript);
    console.log("Backend response from manualLoginSignUpSaga: ", response);
    yield put(authLoginApiResponseSuccess(AuthLoginActionTypes.MANUAL_LOGIN_SIGNUP, response));
    // showSuccessNotification(`🚀 Booking details fetched successfully!`);

  } catch (error: any) {
    console.error(" manualLoginSignUpSaga Saga error  details:", error.message);
    yield put(authLoginApiResponseError(AuthLoginActionTypes.MANUAL_LOGIN_SIGNUP, error.message));
    // showErrorNotification("Execution failed: " + error.message);
  }
}




export default function* authSaga() {
  yield takeEvery(AuthLoginActionTypes.LOGIN_USER, loginUser);
  yield takeEvery(AuthLoginActionTypes.LOGOUT_USER, logoutUser);
  yield takeLatest(AuthLoginActionTypes.SOCIAL_LOGIN, socialLogin);
  yield takeLatest(AuthLoginActionTypes.GOOGLE_VERIFY, googleVerify);
  yield takeLatest(AuthLoginActionTypes.GMAIL_VERIFY, gmailVerify);
  yield takeLatest(AuthLoginActionTypes.CAPTCHA_VERIFY, verifyCaptcha);
  yield takeLatest(AuthLoginActionTypes.ADMIN_OTP_VERIFY, verifyAdminOTP);
  yield takeLatest(AuthLoginActionTypes.SEND_ADMIN_OTP, sendEmailOTP);
  yield takeLatest(AuthLoginActionTypes.REGISTRATION_OPTIONS_PASSKEY, registrationOptionsPasskeySaga);
  yield takeLatest(AuthLoginActionTypes.REGISTRATION_VERIFY_PASSKEY, registrationVerifyPasskeySaga);
  yield takeLatest(AuthLoginActionTypes.LOGIN_OPTIONS_PASSKEY, loginOptionsPasskeySaga);
  yield takeLatest(AuthLoginActionTypes.LOGIN_VERIFY_PASSKEY, loginVerifyPasskeySaga);
  yield takeLatest(AuthLoginActionTypes.REGISTERED_DEVICES_PASSKEY, registeredDevicesPasskeySaga);
  yield takeLatest(AuthLoginActionTypes.SESSION_CHECK, sessionCheckSaga);
  yield takeLatest(AuthLoginActionTypes.MANUAL_LOGIN_SIGNUP, manualLoginSignUpSaga);






}
